export const range = (size: number, startAt: number = 0): Array<number> =>  Array.from(Array(size).keys()).map(i => i + startAt);

export const wrap = (n: number, reel: Array<unknown>) => n % reel.length;
export function randRange(min: number, max: number) { return Math.floor(Math.random() * (max - min + 1)) + min; }
export function isNumeric(str: any) {
  if (str == null) {
    return false;
  }
  const regx = /^[-+]?\d*\.?\d+(?:[eE][-+]?\d+)?$/;
  return regx.test(str);
}
export const getSymbolCountsFromWindow = (window: string[][]) => {
  const symbols: {[key: string]: number} = {};
  window.forEach((row) => row.forEach((symbol) => {
    !symbols[symbol] && (symbols[symbol] = 0);
    symbols[symbol] += 1;
  }));
  return symbols;
};

export const generateWindowFromReelStrips = (props: { reelIndexes: number[], reelStrips: string[][], reels: number, rows: number}) => {
  const { reels, rows } = props;

  // Defensive: some persisted scenarios/configs can omit reelIndexes or reelStrips.
  const reelIndexes = Array.isArray((props as any).reelIndexes) ? (props as any).reelIndexes as number[] : [];
  const reelStrips = Array.isArray((props as any).reelStrips) ? (props as any).reelStrips as string[][] : [];

  const w: string[][] = range(reels).map(() => Array(rows).fill(''));

  for (let ri = 0; ri < reels; ri++) {
    const strip = reelStrips[ri];
    if (!Array.isArray(strip) || strip.length === 0) { continue; }

    const baseIndex = (typeof reelIndexes[ri] === 'number' && Number.isFinite(reelIndexes[ri])) ? reelIndexes[ri] : 0;

    for (let ci = 0; ci < rows; ci++) {
      const n = baseIndex + ci;
      const c = n % strip.length;
      const b = c < 0 ? (strip.length + c) : c;
      w[ri][ci] = strip[b];
    }
  }

  return w;
}